import PropTypes from 'prop-types';
import React from 'react';

import Formsy from 'formsy-react';
import { Row, Col, Button, Label, FormGroup, SheetBody, SheetFooter, Tabs, TabsContent, TabsList, TabsTrigger } from 'twyne-new.ui';

import InfoTip from 'components/InfoTip';
import Input from 'components/form/Input';
import InputDecimal from 'components/form/InputDecimal';
import Select from 'components/form/Select';
import Slider from 'components/form/Slider';
import Switch from 'components/form/Switch';
import siteStore from 'modules/admin/stores/site';
import allocationStore from 'modules/offer/stores/allocation';
import history from 'utils/history';

import ScrubOptions from '../../../components/ScrubOptions';

import OverrideAttributes from './OverrideAttibutes';

class SubIdForm extends React.Component {
  state = {
    active: true,
    scrub_percent: 100,
    allocationOptions: [],
  }

  componentDidMount() {
    const { data, allocationID } = this.props

    this.setState(() => {
      let state = {}
      if (JSON.stringify(data) !== '{}') {
        state = { ...data }
      } else {
        allocationStore.fetch(allocationID, true).then(res => {
          this.setState({ allocation: res.data })
        })
      }
      if (allocationID) {
        state.allocation_id = allocationID
      }

      return state
    })

    this.loadAllocationOptions();
  }

  loadAllocationOptions = () => allocationStore.all().then(response => {
    const opts = response.data.map(allocation => ({ value: allocation.id, label: `[${allocation.id}] ${allocation.offer && allocation.offer.name} - ${allocation.publisher && allocation.publisher.name}` }));
    this.setState({ allocationOptions: opts });
  })

  loadOverrideData = async () => {
    const { allocationID } = this.props
    await allocationStore.fetch(allocationID, true)
    const { options } = allocationStore.entity.object.throttling || {}
    if (options) {
      return { options }
    }

    await siteStore.fetch(this.state.allocation.site_id);
    return siteStore.entity.object.throttling || {}
  }

  handleValidSubmit = model => {
    if (model.throttling && model.throttling.options && model.throttling.options.threshold) {
      model.throttling.options.threshold = model.throttling.options.threshold / 100
    }
    model.override_attributes = model.override_attributes || false
    this.props.handleSubmit(Object.assign(this.state, model));
  }

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else {
      history.goBack();
    }
  }

  Payout = () => {
    const dynamicLabel = this.state.cost_mode === "dynamic" ? 'Default' : ''

    const handleCost = option => {
      const cost_mode = option.value
      this.setState({ cost_mode })
    }

    const handleUpdatePayout = value => value && this.setState({ payout: value })

    return <>
      <Col size="4">
        <FormGroup>
          <div className='flex items-center gap-1'>
            <Label id="cost-mode">Cost Mode</Label>
            <InfoTip id='dynamic-cost' color="neutral" disabled>
              Dynamic cost mode will require on the user to send the paramater <strong>cost</strong> to the first call to user enroll.
            </InfoTip>
          </div>
          <Select name="cost_mode" clearable={false} options={COST_MODE_OPTIONS}
            value={this.state.cost_mode} handleOnChange={handleCost} required />
        </FormGroup>
      </Col>
      <Col size="4">
        <FormGroup>
          <Label>{dynamicLabel} Payout</Label>
          <InputDecimal name="payout" value={this.state.payout} required getErrorMessage={() => "Field required."} onChange={handleUpdatePayout} />
        </FormGroup>
      </Col>
      <Col size="4">
        <FormGroup>
          <Label>{dynamicLabel} Mobile Payout</Label>
          <InputDecimal name="mobile_payout" value={this.state.mobile_payout} />
        </FormGroup>
      </Col>
    </>
  }

  render() {
    const { allocation, override_attributes, custom, id } = this.state
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody className='pt-0'>
          <Tabs defaultValue='details'>
            <TabsList>
              <TabsTrigger value='details'>Details</TabsTrigger>
              {allocation && <TabsTrigger value='attributes'>Attributes</TabsTrigger>}
            </TabsList>
            <TabsContent value='details'>
              <Row>
                <Col size="4">
                  <FormGroup>
                    <Label>Allocation</Label>
                    {Array.isArray(this.state.allocationOptions) ? <Select required
                      disabled={this.props.allocationID ? true : false}
                      name="allocation_id"
                      options={this.state.allocationOptions}
                      value={this.state.allocation_id ? Number(this.state.allocation_id) : null}
                    /> : null}
                  </FormGroup>
                </Col>
                <Col size="4">
                  <FormGroup>
                    <Label>Subid</Label>
                    <Input name="subid" value={this.state.subid} />
                  </FormGroup>
                </Col>
                <Col size="4">
                  <FormGroup>
                    <Label>Active</Label>
                    <Switch name="active" value={this.state.active || false} />
                  </FormGroup>
                </Col>
                <this.Payout />
                {!this.state.allocation ? null : <>
                  <ScrubOptions payout={this.state.payout} throttling={this.state.throttling} origin='subid' loadOverrideData={this.loadOverrideData}>
                    <Col size="8">
                      <FormGroup>
                        <Label>Scrub Percent</Label>
                        <Slider className='pt-3' name="scrub_percent" min={0} max={100} value={this.state.scrub_percent} />
                      </FormGroup>
                    </Col>
                  </ScrubOptions>
                </>}
              </Row>
            </TabsContent>
            {allocation && <TabsContent value='attributes'>
              <OverrideAttributes
                override={override_attributes}
                attributes={custom || allocation.custom}
                onChange={state => this.setState(state)}
                offerId={allocation.offers[0]?.id}
              />
            </TabsContent>}
          </Tabs>
        </SheetBody>
        <SheetFooter>
          <Button onClick={this.handleCancel} variant="ghost">Cancel</Button>
          <Button type="submit" color="accent">Save</Button>
        </SheetFooter>
      </Formsy>
    );
  }
}

SubIdForm.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any,
  allocationID: PropTypes.any,
};

export default SubIdForm;

const COST_MODE_OPTIONS = [
  { label: 'Static', value: 'static' },
  { label: 'Dynamic', value: 'dynamic' },
]
